import { Component, OnInit } from '@angular/core';
import { Reset } from 'src/app/models/reset';
import { SecurityService } from 'src/app/services/security.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';
import { Confirm } from 'src/app/models/confirm';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
    selector: 'app-password-confirm',
    templateUrl: './password-confirm.component.html',
    styleUrls: ['./password-confirm.component.css']
})
export class PasswordConfirmComponent implements OnInit {

    public confirmFormGroup: FormGroup;
    private currentRecuperacao: Reset;

    constructor(
        private formBuilder: FormBuilder,
        private securityService: SecurityService,
        private alertService: NewAlertService,
        private router: Router) { }

    ngOnInit() {
        this.securityService.currentRecuperacao.subscribe(
            response => {
                this.currentRecuperacao = response;
            }
        );

        if (this.currentRecuperacao === null) {
            this.router.navigate(['']);
        }

        this.confirmFormGroup = this.formBuilder.group({
            token: new FormControl('', [
                Validators.required,
                Validators.minLength(6)
            ]),
            senha: new FormControl('', [
                Validators.required,
                Validators.minLength(5),
                Validators.maxLength(100)
            ]),
            senhaConfirmacao: new FormControl('', [
                Validators.required,
                GenericValidator.mustMatch('senha')
            ]),
            email: new FormControl(this.currentRecuperacao.email, [

            ]),
            cpf: new FormControl(this.currentRecuperacao.cpf, [

            ])
        });
    }

    public get form() { return this.confirmFormGroup.controls; }

    onSubmit(confirm: Confirm) {
        if (this.confirmFormGroup.valid) {
            this.securityService.confirmar(confirm).subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {
                        this.alertService.success(response.message);
                        setTimeout(() => {
                            this.router.navigate(['']);
                        }, 6000);
                    } else {
                        this.alertService.error(response.message);
                    }
                }, error => {
                    this.confirmFormGroup.controls.token.setValue('');
                    this.confirmFormGroup.controls.token.updateValueAndValidity();
                    this.confirmFormGroup.controls.senha.setValue('');
                    this.confirmFormGroup.controls.senha.updateValueAndValidity();
                    this.confirmFormGroup.controls.senhaConfirmacao.setValue('');
                    this.confirmFormGroup.controls.senhaConfirmacao.updateValueAndValidity();
                    this.alertService.error('Erro ao alterar senha, tente novamente');
                }
            );
        }
    }

}
